const STORAGE_KEY = "slotique_onboarding_business_id";

export function storedBusinessId(): string | null {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function persistBusinessId(id: string): void {
  window.localStorage.setItem(STORAGE_KEY, id);
}

export function clearBusinessId(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
